module.exports = __webpack_public_path__ + "assets/edit.svg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/edit.svg
// module id = 350
// module chunks = 0